module.exports = __webpack_public_path__ + "static/img/iphone_ldttitle3.d6d630c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldttitle3.png
// module id = 9D7W
// module chunks = 0